<template>
  <div>
    <div class="modal-body" style="min-height: 500px;">
      <MonacoEditor :value="text" @update:value="val => text = val" :language="getLanguage(file.name)" theme="vs-dark"
        style="height: 480px; width: 100%;" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="$emit('close')">Chiudi</button>
      <button type="button" class="btn btn-primary" @click="salva">Salva</button>
    </div>
  </div>
</template>

<script>
import MonacoEditor from '@guolao/vue-monaco-editor'

export default {
  props: {
    file: Object,
    initialContent: String
  },
  data() {
    return {
      text: this.initialContent
    }
  },
  components: { MonacoEditor },
  methods: {
    getLanguage(name) {
      const ext = name.split('.').pop().toLowerCase()
      return {
        js: 'javascript',
        ts: 'typescript',
        php: 'php',
        html: 'html',
        css: 'css',
        json: 'json',
        vue: 'html',
        py: 'python',
        cpp: 'cpp',
        c: 'c'
      }[ext] || 'plaintext'
    },
    salva() {
      utils.ajax('ftp/save-code-file', {
        path: this.file.fullPath,
        content: this.text
      }, response => {
        if (response.esito == 0) {
          utils.alert.success('Salvato con successo');
          this.$emit('salvato');
        } else {
          utils.alert.warning('Errore durante il salvataggio');
        }
      });
    }
  },
  watch: {
    initialContent(newVal) {
      this.text = newVal
    }
  }

}
</script>
